<template>
  <!-- Компонент ничего не рендерит -->
</template>

<script>
import { onMounted, onUnmounted } from 'vue'
import { Tooltip } from 'bootstrap'

export default {
  name: 'TooltipProvider',
  setup() {
    const instances = new Map()

    const create = (el) => {
      if (!el.dataset.tooltip || instances.has(el)) return
      instances.set(el, new Tooltip(el, {
        title: el.dataset.tooltip,
        placement: el.dataset.tooltipPosition || 'top',
        trigger: 'hover focus',
        container: 'body',
        boundary: 'window',
      }))
    }

    const dispose = (el) => {
      const t = instances.get(el)
      if (t) { t.dispose(); instances.delete(el) }
    }

    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1) {
            if (node.matches?.('[data-tooltip]')) create(node)
            node.querySelectorAll?.('[data-tooltip]').forEach(create)
          }
        }
        for (const node of m.removedNodes) {
          if (node.nodeType === 1) {
            if (node.matches?.('[data-tooltip]')) dispose(node)
            node.querySelectorAll?.('[data-tooltip]').forEach(dispose)
          }
        }
      }
    })

    onMounted(() => {
      document.querySelectorAll('[data-tooltip]').forEach(create)
      observer.observe(document.body, { childList: true, subtree: true })
    })

    onUnmounted(() => {
      observer.disconnect()
      instances.forEach(t => t.dispose())
      instances.clear()
    })

    return {}
  }
}
</script>